import React from 'react';

import { Box } from '@adsk/alloy-react-box';
import { OverflowTooltip } from '@adsk/alloy-react-tooltip';

import { Spec } from '../../types';

interface SpecCellProps {
  spec: Spec;
}

const SpecCell: React.FC<SpecCellProps> = ({ spec }) => {
  const { identifier, title } = spec;

  return (
    <Box width="100%">
      <Box typography="ellipsis">{identifier}</Box>
      <Box typography="ellipsis" color="charcoal700" width="100%">
        <OverflowTooltip>{title}</OverflowTooltip>
      </Box>
    </Box>
  );
};

SpecCell.displayName = 'SubmittalsSpecCell';

export default SpecCell;
